import { Grid, Typography } from "@mui/material";
import { formatModelName, hasPositiveUsage } from "components/ai-usage/ai-usage-modal";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import Limits from "./components/limits";
import useAIModelsUsage from "./hooks";

type AIConsumptionProps = {
  email: string;
  refetchOnUsageUpdate?: boolean;
}

const SmallAIConsuption: FC<AIConsumptionProps> = ({ email, refetchOnUsageUpdate = true }) => {
  const {
    models
  } = useAIModelsUsage(email, refetchOnUsageUpdate);
  const { t } = useTranslation();

  const qualifyingModels = models
    .filter((model) => model.windows.some(hasPositiveUsage))
    .sort((a, b) => formatModelName(a.model).localeCompare(formatModelName(b.model)));

  if (qualifyingModels.length === 0) {
    return (
      <Typography
        variant="caption"
        style={{ fontWeight: 500, fontSize: "0.65rem", fontStyle: "italic", color: "#ffffff99" }}
      >
        {t("inference:no-usage")}
      </Typography>
    );
  }

  return (
    <Grid container direction="column" wrap="nowrap" style={{ paddingBottom: 7 }}>
      <Grid item>
        <Grid container direction="row">
          <Grid item xs={2} style={{ padding: 1, display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
            <Typography variant="caption" style={{ fontWeight: 500, fontSize: "0.65rem" }}>{t("inference:current-limits")}</Typography>
          </Grid>
          <Grid item xs style={{ padding: 1, textAlign: "center" }}>
            <Typography variant="caption" style={{ fontWeight: 500, fontSize: "0.65rem" }}>{t("inference:hourly")}</Typography>
          </Grid>
          <Grid item xs style={{ padding: 1, textAlign: "center" }}>
            <Typography variant="caption" style={{ fontWeight: 500, fontSize: "0.65rem" }}>{t("inference:weekly")}</Typography>
          </Grid>
          <Grid item xs style={{ padding: 1, textAlign: "center" }}>
            <Typography variant="caption" style={{ fontWeight: 500, fontSize: "0.65rem" }}>{t("inference:monthly")}</Typography>
          </Grid>
        </Grid>

        {qualifyingModels.map((model) => (
          <Limits
            key={model.model}
            mode={formatModelName(model.model)}
            windows={model.windows}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default SmallAIConsuption;
